<div>
    <div id="chart-{{graph.code}}" style="display: block">
        <canvas baseChart
            [data]="values"
            [labels]="labels"
            [options]="options"
            chartType="bar"
            [colors]="colors">
        </canvas>
    </div>
</div>
